import { Fragment } from 'react';
import { observer } from 'mobx-react';

import Heading from '@/common/components/Heading/Heading';
import { useNetBoxStore } from '@/netbox/stores/NetBoxStore';

import LoadingTaskItem from './LoadingTaskItem/LoadingTaskItem';
import styles from './LoadingTaskList.module.css';

function LoadingTaskList() {
  const { tasks } = useNetBoxStore();

  if (!tasks || tasks.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <div className={styles.title}>
        <Heading appearance="h3">Downloads</Heading>
      </div>

      {tasks.map((task) => (
        <LoadingTaskItem key={task.id} task={task} />
      ))}
    </Fragment>
  );
}

export default observer(LoadingTaskList);
